import { gmiRequest } from 'actions/request';
import actions from '@ehi/global-marketing-interface/lib/actions';
import services from '@ehi/global-marketing-interface/lib/services';

export const addAdditionalDriverByName =
  ({ firstName, lastName }) =>
  (dispatch) =>
    dispatch(
      gmiRequest({
        action: actions.request({
          service: services.gma.reservations.addAdditionalDriverByName,
          data: {
            params: {
              firstName,
              lastName,
            },
          },
        }),
      })
    );
